// @ts-check
import app from './app';
import './style.scss';

app();
